<script setup lang="ts">
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import api from "@/modules/api";
import { DispatchTemplate, Worldview } from "@/types/entity";
import { onMounted, ref } from "vue";
import WorldMissionCard from "./WorldMissionCard.vue";
import WorldMissionTemplateList from "./WorldMissionTemplateList.vue";
import { routerBack } from "@/use/go";

const dispatchTemplateList = ref<DispatchTemplate[]>([]);
const loading = ref(false);

const worldviewMap = ref<Record<number, Worldview>>({});
const worldviewMissionMap = ref<Record<number, DispatchTemplate[]>>({});
const activeWorldviewId = ref<number | null>(null);

const goBack = () => {
  if (activeWorldviewId.value) {
    activeWorldviewId.value = null;
  } else {
    routerBack();
  }
};

onMounted(async () => {
  try {
    loading.value = true;
    const res = await api.readDispatchTemplatePage({
      pagination: { page: 1, perPage: 999 },
    });

    res.page.data.forEach((item) => {
      const worldview = item.location!.worldview!;
      worldviewMap.value[worldview.id] = worldview;
      if (!worldviewMissionMap.value[worldview.id])
        worldviewMissionMap.value[worldview.id] = [];

      worldviewMissionMap.value[worldview.id].push(item);
    });

    dispatchTemplateList.value = res.page.data;
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <div class="grid grid-rows-[auto_1fr] h-full bg-base-300">
    <ThreadsNav :show-back="true" class="bg-base-300" :go-back="goBack">
      <template #center><div>世界事件</div></template>
    </ThreadsNav>
    <div class="w-full h-full overflow-hidden">
      <div
        v-if="loading"
        class="flex flex-col justify-center items-center h-full p-2"
      >
        <div class="loading loading-sm"></div>
      </div>
      <div v-else-if="Object.keys(worldviewMap).length === 0">
        <VanEmpty description="暂时没有世界任务，请稍后再来" />
      </div>
      <div v-else class="p-2 w-full h-full overflow-y-auto flex flex-col gap-4">
        <div v-if="!activeWorldviewId" class="flex flex-col gap-2">
          <WorldMissionCard
            v-for="item in worldviewMap"
            :worldview="item"
            :key="item.id"
            :template-list="worldviewMissionMap[item.id]"
            @click="activeWorldviewId = item.id"
          />
        </div>

        <div v-else class="flex flex-col gap-2">
          <div class="text-sm font-semibold text-base-content/80 px-1">
            任务列表
          </div>
          <WorldMissionTemplateList
            :template-list="worldviewMissionMap[activeWorldviewId]"
          />
        </div>
      </div>
    </div>
  </div>
</template>
